import { render, staticRenderFns } from "./NotificationSettings.vue?vue&type=template&id=cac5fcac"
import script from "@/scripts/settings/notificationSettings.js?vue&type=script&lang=js&external"
export * from "@/scripts/settings/notificationSettings.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports